<template>
  <div>
    <agile-table
      :data="invoices"
      :data-type="dataType"
      :table-meta="tableMeta"
      :filter-meta="filterMeta"
      :action-meta="actionMeta"
      :column-meta="columnMeta"
      @rowAction="rowAction"
      @fieldAction="fieldAction"
      @tableAction="tableAction" />
      <slideout-panel />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AgileTable from '@/components/table/AgileTable'
import InvoicePreviewModal from '@/components/modals/InvoicePreviewModal'
import FileViewerModal from '@/components/modals/FileViewerModal'

export default {
  components: {
    AgileTable
  },

  data () {
    return {
      debounceDelay: process.env.DEBOUNCE_DELAY,

      tableMeta: {
        heading: 'Fakturor » Reskontra',
        headingIcon: 'fa-file-invoice-dollar',
        displayPagination: true
        /*
        actions: [{
          label: 'Fakturera',
          action: 'goToInvoice',
          iconClass: 'fal fa-file-invoice'
        }]
        */
      },

      filterMeta: [{
        fieldId: 'serialNumber',
        type: 'string',
        label: 'Löpnummer'
      }, {
        fieldId: 'customerName',
        type: 'string',
        label: 'Kund'
      }, {
        fieldId: 'projectCode',
        type: 'string',
        label: 'Projektnummer'
      }, {
        fieldId: 'projectOwnerUserInitials',
        type: 'string',
        label: 'Ansvarig'
      }, {
        fieldId: 'invoiceType',
        type: 'select',
        label: 'Typ',
        options: [
          {
            key: 'debit',
            value: 'Faktura'
          },
          {
            key: 'credit',
            value: 'Kreditfaktura'
          }
        ]
      }, {
        fieldId: 'status',
        type: 'select',
        label: 'Status',
        options: [
          /*
          {
            key: 'Skapad',
            value: 'Fdbk'
          }, */
          {
            key: 'Sent',
            value: 'Registrerad'
          },
          {
            key: 'Posted',
            value: 'Bokförd'
          },
          {
            key: 'Paid',
            value: 'Betald'
          },
          {
            key: 'Overdue',
            value: 'Förfallen'
          },
          {
            key: 'Cancelled',
            value: 'Makulerad'
          }
        ]
      }],

      columnMeta: {
        hasActions: true,
        items: [{
          fieldId: 'serialNumber',
          label: 'Löpnr.'
        },
        {
          fieldId: 'projectCode',
          label: 'Projektnummer'
        },
        {
          fieldId: 'objectName',
          label: 'Objekt'
        },
        {
          fieldId: 'customerName',
          label: 'Kund'
        },
        {
          fieldId: 'projectOwnerUserInitials',
          label: 'Ansvarig'
        },
        {
          fieldId: 'invoiceType',
          label: 'Typ',
          dataType: 'translate',
          translations: [{
            key: 'Debit',
            value: 'Faktura'
          }, {
            key: 'Credit',
            value: 'Kreditfaktura'
          }]
        },
        {
          fieldId: 'refSerialNumberPadded',
          label: 'Avser'
        },
        {
          fieldId: 'status',
          label: 'Status',
          dataType: 'translate',
          translations: [{
            key: 'Created',
            value: 'Endast fdBk'
          },
          {
            key: 'Sent',
            value: 'Registrerad'
          },
          {
            key: 'Posted',
            value: 'Bokförd'
          },
          {
            key: 'Paid',
            value: 'Betald'
          },
          {
            key: 'Overdue',
            value: 'Förfallen'
          },
          {
            key: 'Cancelled',
            value: 'Makulerad'
          }]
        },
        {
          fieldId: 'displayDate',
          label: 'Datum',
          dataType: 'date',
          disableOrdering: true
        },
        /*
        {
          fieldId: 'statusDate',
          label: 'S Datum',
          dataType: 'date'
        },
        {
          fieldId: 'dueDate',
          label: 'D Datum',
          dataType: 'date'
        },
        {
          fieldId: 'ocr',
          label: 'OCR'
        },
        */
        /*
        {
          fieldId: 'numberOfWorkOrders',
          label: 'Insatser',
          dataType: 'number'
        },
        {
          fieldId: 'numberOfWorkOrderLines',
          label: 'Insatsrader',
          dataType: 'number'
        },
        {
          fieldId: 'amountInvoiceable',
          label: 'Fakturerbart',
          dataType: 'number'
        }
        */
        {
          fieldId: 'sumTotal',
          label: 'Exkl. moms',
          dataType: 'currency'
        }]
      },

      actionMeta: {
        type: 'buttons',
        items: [{
          label: '',
          action: 'creditInvoice',
          iconClass: 'fal fa-reply',
          showCondition (item) {
            return item['invoiceType'] === 'Debit' && !item['credited']
          },
          disableCondition (item) {
            return item['status'] !== 'Posted' && item['status'] !== 'Paid' && item['status'] !== 'Overdue'
          }
        },
        {
          label: '',
          action: 'downloadInvoice',
          iconClass: 'fal fa-download'
        },
        {
          label: '',
          action: 'openFolder',
          iconClass: 'fal fa-folder-open'
        }]
      }
    }
  },
  watch: {
    'invoices.filter': {
      handler () {
        this.invoices.currentPage = 1
        this.getListDataByContext()
      },
      deep: true
    }
  },

  computed: {
    ...mapState({
      invoices (state) {
        if (this.$route.name === 'Invoices_Archive_My') {
          return state.invoicesOwner.all
        } else if (this.$route.name === 'Invoices_Archive_Overdue') {
          return state.invoicesOverdue.all
        } else {
          return state.invoicesArchive.all
        }
      }
    }),

    dataType (state) {
      if (this.$route.name === 'Invoices_Archive_My') {
        return 'invoicesOwner'
      } else if (this.$route.name === 'Invoices_Archive_Overdue') {
        return 'invoicesOverdue'
      } else {
        return 'invoicesArchive'
      }
    }
  },

  methods: {
    ...mapActions('invoicesOwner', ['review', 'downloadInvoicePdf', 'recreateInvoicePdf']),
    ...mapActions({
      getInvoicesOwner: 'invoicesOwner/getListData',
      getInvoicesOverdue: 'invoicesOverdue/getListData',
      getInvoicesArchive: 'invoicesArchive/getListData',
      initializeOwner: 'invoicesOwner/initialize',
      initializeOverdue: 'invoicesOverdue/initialize',
      initializeArchive: 'invoicesArchive/initialize'
    }),

    recreateInvoicePdfTrigger (invoice) {
      this.recreateInvoicePdf(invoice.invoiceId)
    },

    getListDataByContext () {
      if (this.$route.name === 'Invoices_Archive_My') {
        this.getInvoicesOwner()
      } else if (this.$route.name === 'Invoices_Archive_Overdue') {
        this.getInvoicesOverdue()
      } else {
        this.getInvoicesArchive()
      }
    },

    initializeByContext () {
      if (this.$route.name === 'Invoices_Archive_My') {
        this.initializeOwner()
      } else if (this.$route.name === 'Invoices_Archive_Overdue') {
        this.initializeOverdue()
      } else {
        this.initializeArchive()
      }
    },

    rowAction (action, invoice) {
      switch (action) {
        case 'creditInvoice':
          this.openCreditInvoicePreviewModal(invoice)
          break

        case 'downloadInvoice':
          this.downloadInvoicePdf(invoice)
          break

        case 'openFolder':
          // this.$panel(FileViewerModal, { id: invoice.projectId, defaultPath: 'Ekonomi' })
          this.openFileViewerModal(invoice)
          break

        case 'recreateInvoicePdfTrigger':
          this.recreateInvoicePdfTrigger(invoice)
          break

        default:
          this.$alert(action + ' is not defined!')
          break
      }
    },

    fieldAction (action, project) {
      switch (action) {
        default:
          this.$alert(action + ' is not defined!')
          break
      }
    },

    tableAction (action) {
      this.$router.push({ name: 'Invoices' })
    },

    openCreditInvoicePreviewModal (invoice) {
      this.$panel(InvoicePreviewModal, { invoiceId: invoice.invoiceId })
    },

    openFileViewerModal (invoice) {
      let displayWebExplorer = true

      if (window.isElectron()) {
        let error = false

        let result
        try {
          result = window.Bridge.openFileExplorer(invoice.projectCode)
        } catch (e) {
          error = true
        }

        if (result) {
          if (result.ok) {
            if (result.message) {
              this.$toast(result.message, 'info')
              displayWebExplorer = false
            } else {
              error = true
            }
          } else {
            if (result.message) {
              this.$toast(result.message, 'error')
            } else {
              error = true
            }
          }
        }
        if (error) {
          this.$toast('Inget svar från applikationen', 'error')
        }
      }

      if (displayWebExplorer === true) {
        this.$panel(FileViewerModal, { id: invoice.projectId, defaultPath: 'Ekonomi' })
      }
    }
  },
  created () {
    this.initializeByContext()

    if (this.$store.state.auth.user.initials === 'NA') {
      this.actionMeta.items.push({
        label: '',
        action: 'recreateInvoicePdfTrigger',
        iconClass: 'fal fa-plus'
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/Admin/Invoices/InvoiceArchivePage.vue